import { useState } from 'react';

import { createContainer } from 'unstated-next';

const useModal = () => {
    const [modalContent, setModalContent] = useState<any>([]);
    const [modalButtons, setModalButtons] = useState<any>([]);

    const pushModalContent = (content: any, buttons: any = undefined) => {
        setModalContent(prevArray => [...prevArray, content]);
        setModalButtons(prevArray => [...prevArray, buttons]);
    };
    const popModalContent = () => {
        setModalContent(prevArray => prevArray.slice(0, -1));
        setModalButtons(prevArray => prevArray.slice(0, -1));
    };

    return {
        modalContent,
        setModalContent,
        modalButtons,
        setModalButtons,
        pushModalContent,
        popModalContent
    };
};

const ModalContainer = createContainer(useModal);

export default ModalContainer;
